module.exports = __webpack_public_path__ + "static/img/tendereeReturned.d4d15bfd.png";